"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Logo } from "./Logo";
import { Button } from "./Button";

const NAV = [
  { href: "/builder/", label: "RAMS builder" },
  { href: "/templates/", label: "Templates" },
  { href: "/categories/", label: "Categories" },
  { href: "/tools/", label: "Tools" },
  { href: "/guides/", label: "Guides" },
  { href: "/assets/", label: "Resources" },
  { href: "/how-it-works/", label: "How it works" },
];

function isActive(pathname: string, href: string): boolean {
  const path = pathname.endsWith("/") ? pathname : `${pathname}/`;
  return path === href || (href !== "/" && path.startsWith(href));
}

export function Header() {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  return (
    <header className="sticky top-0 z-50 border-b border-line bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between px-5">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((n) => {
            const active = isActive(pathname, n.href);
            return (
              <Link
                key={n.href}
                href={n.href}
                aria-current={active ? "page" : undefined}
                className={`text-[0.95rem] font-medium transition-colors hover:text-ink ${
                  active ? "text-ink underline decoration-emerald decoration-2 underline-offset-8" : "text-body"
                }`}
              >
                {n.label}
              </Link>
            );
          })}
        </nav>
        <div className="flex items-center gap-3">
          <Button href="/builder/" variant="primary" className="whitespace-nowrap !px-4 !py-2.5 !text-sm sm:!px-5">
            Build a RAMS draft
          </Button>
          <button
            type="button"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-lg text-ink hover:bg-mist lg:hidden"
          >
            <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              {open ? <path d="M6 6l12 12M18 6 6 18" /> : <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>}
            </svg>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-line bg-white lg:hidden">
          <div className="mx-auto flex max-w-7xl flex-col px-5 py-2">
            {NAV.map((n) => (
              <Link
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                aria-current={isActive(pathname, n.href) ? "page" : undefined}
                className={`border-b border-line py-3 text-base font-medium last:border-0 ${
                  isActive(pathname, n.href) ? "text-emerald-deep" : "text-ink"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}
